<template>
  <transition name="fade">
    <div v-if="active" class="overlay">
      <div class="dots-loader">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "LoadingOverlay",
  props: {
    active: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dots-loader {
  display: flex;
  gap: 8px;
}

.dots-loader span {
  width: 12px;
  height: 12px;
  background-color: #f47b20;
  border-radius: 50%;
  animation: bounce-up 1.4s infinite ease-in-out both;
}

.dots-loader span:nth-child(1) {
  animation-delay: -0.32s;
}
.dots-loader span:nth-child(2) {
  animation-delay: -0.16s;
}
.dots-loader span:nth-child(3) {
  animation-delay: 0;
}

@keyframes bounce-up {
  0%,
  80%,
  100% {
    transform: translateY(0);
  }
  60% {
    transform: translateY(-40px);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/LoadingOverlay.vue